
import Register from './Register'
export default {
    'register': Register
}
